import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Tag, Marquee } from "../components/Shared";
import { IMAGES, MARQUEE_CITIES } from "../data/content";

const MILESTONES = [
  { k: "NYFW SS/17", v: "The first New York statement" },
  { k: "NYFW SS/18", v: "The return — sharper, surer" },
  { k: "NYFW SS/19", v: "Fun, flirty, feminine — vacay vibes on the runway" },
  { k: "SMARÁ SS/23", v: "The golden decade, reimagined" },
];

const Global = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} className="relative overflow-hidden bg-ink" data-testid="global-section">
      <div className="always-dark relative h-[60vh] overflow-hidden md:h-[75vh]">
        <motion.img
          src={IMAGES.global}
          alt="Rutu Bhonsle on the world stage — from India to international fashion capitals"
          loading="lazy"
          className="h-[120%] w-full object-cover"
          style={{ y }}
        />
        <div className="absolute inset-0 bg-ink/55" />
        <div className="absolute inset-0 flex flex-col items-start justify-center px-5 sm:px-10">
          <div className="mx-auto w-full max-w-[1600px]">
            <Reveal><Tag>Global Presence</Tag></Reveal>
            <h2 className="mt-6 font-serif text-6xl font-light leading-[0.95] tracking-tight sm:text-8xl">
              FROM INDIA.<br /><span className="text-bone/60">TO THE WORLD.</span>
            </h2>
            <Reveal delay={0.3}>
              <p className="mt-6 max-w-md text-lg font-light text-bone/80">A distinctly Indian voice with a global fashion language.</p>
            </Reveal>
          </div>
        </div>
      </div>

      <div className="mx-auto grid max-w-[1600px] gap-px bg-line/10 px-0 sm:grid-cols-2 lg:grid-cols-4" data-testid="global-milestones">
        {MILESTONES.map((m, i) => (
          <Reveal key={m.k} delay={i * 0.1} className="bg-ink">
            <div className="group p-10 transition-colors duration-500 hover:bg-coal" data-testid={`milestone-${i}`}>
              <p className="font-serif text-2xl font-normal tracking-wide text-flame">{m.k}</p>
              <p className="mt-3 text-sm font-light text-fog">{m.v}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Marquee items={MARQUEE_CITIES} className="border-y border-line/10 py-8" />
    </section>
  );
};

export default Global;
